



























































































































import IListTypesOutbounds from '@/store/models/IListTypesOutbounds';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListTypesOutboundsSelector extends Vue {
    searchListTypesOutbounds: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListTypesOutbounds = {
        id: "",
        name: "",
        canDelete: true,
        idCompany: ""
    }
    defaultItem : IListTypesOutbounds = {
        id: "",
        name: "",
        canDelete: true,
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListTypesOutboundsList !: IListTypesOutbounds[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListTypesOutbounds : IListTypesOutbounds[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Outbound type' : 'Edit Outbound type'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListTypesOutbounds() {
        this.selectedListTypesOutbounds = [];
    }

    editListTypesOutbounds (item: any, dbox = true) {
        this.editedIndex = this.ListTypesOutboundsList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListTypesOutbounds () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListTypesOutbounds[0]) {
                this.close();
                this.$emit('editListTypesOutbound', this.editedItem);
                Object.assign(this.ListTypesOutboundsList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListTypesOutbounds[0] = this.editedItem;
                this.$emit('saveListTypesOutbound', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListTypesOutbounds (TypesOutbounds: IListTypesOutbounds) {
        this.$emit('deleteListTypesOutbound', TypesOutbounds);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListTypesOutbounds(item : any) : void {
        if (!this.selectedListTypesOutbounds.includes(item)) {
            this.selectedListTypesOutbounds = [];
            this.selectedListTypesOutbounds = [item];
        } else {
            this.selectedListTypesOutbounds = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
